import config from '../config';

// Get localStream
export async function getLocalStream(constraints = config.mediaConstraints) {
  let localStream;
  if (!(navigator && navigator.mediaDevices)) {
    console.error('No media devices available');
    return;
  }
  try {
    localStream = await navigator.mediaDevices.getUserMedia(constraints);
    console.debug('Got localStream.');
  } catch (err) {
    console.error('getUserMedia failed with error -->', err);
  }
  return localStream;
}

export function getRandomStartCoord(range) {
  // Get a number between 50 - range to 50 + range
  return 50 + Math.floor(Math.random() * range - range / 2);
}
